<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#">Documents to sign</b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-button size="sm" variant="info" @click="loadDocuments()">
          <img src="img/reload.svg" alt="Reload" width="16px">
        </b-button>
        <!--
        <b-button size="sm" variant="info" @click="doLogin">
          <img src="img/cog.svg" alt="Config" width="16px">
        </b-button>
        -->
      </b-navbar-nav>
    </b-navbar>
    <b-container>
      <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
      <b-list-group style="padding-top: 10px">
        <b-alert v-if="warn" variant="warning" show>{{ warn }}</b-alert>
        <b-list-group-item v-for="doc in docList" v-bind:key="doc.uuid" @click="doPreview(doc)">
          <div><b>Name</b>: {{doc.name}}</div>
          <div><b>Author</b>: {{doc.author}}</div>
          <div><b>Modified</b>: {{doc.modified}}</div>
        </b-list-group-item>
      </b-list-group>
    </b-container>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser';
import moment from 'moment';
import okm from '../api';

export default {
    name: 'DocumentList',
    data() {
      return {
        docList: [],
        error: null,
        warn: null
      }
    },
    mounted() {
      this.loadDocuments();
      this.$store.commit('setCurDoc', null);
    },
    methods: {
      loadDocuments() {
        const folderUuidProperty = 'doc-signer.folder.uuid';
        this.docList = [];
        this.error = null;
        this.warn = null;

        okm.getConfiguration(folderUuidProperty).then(res => {
          console.log("getConfiguration:", res.data);

          if (res.data.value) {
            okm.getNodePath(res.data.value).then(res => {
              const userDocPath = res.data + "/" + this.$store.state.user;
              console.log("User doc path: ", userDocPath);

              okm.getNodeUuid(userDocPath).then(res => {
                console.log("Node uuid: ", res.data);

                okm.getDocuments(res.data).then(res => {
                  res.data.forEach(doc => {
                    const docName = doc.path.split(/\//g).pop();

                    if (docName.toLowerCase().endsWith('.pdf')) {
                      this.docList.push({
                        name: docName,
                        modified: moment(doc.lastModified).format('YYYY-MM-DD HH:mm'),
                        parent: doc.parent,
                        author: doc.author,
                        uuid: doc.uuid
                      });
                    }
                  });

                  if (this.docList.length === 0) {
                    this.warn = "There is no documents";
                  }
                }).catch(err => {
                  this.showError(err);
                });
              }).catch(err => {
                if (err.response.status === 400 || err.response.status === 500) {
                  this.showError("Missing folder " + userDocPath);
                } else {
                  this.showError(err);
                }
              });
            }).catch(err => {
              if (err.response.status === 400 || err.response.status === 500) {
                this.showError("Missing folder " + res.data.value);
              } else {
                this.showError(err);
              }
            });
          } else {
            this.error = 'Missing "' + folderUuidProperty + '" configuration property';
          }
        }).catch(err => {
          this.showError(err);
        });
      },
      doPreview(doc) {
        this.$store.commit('setCurDoc', doc);
        this.$router.push('preview');
      },
      showError(err) {
        Sentry.captureException(err);
        this.error = err;
      },
      doLogin() {
        this.$router.replace('/');
      }
    }
  }
</script>
